import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { ProductTemplateStatus } from 'types/productServiceV2';

export const StatusTagWrapper = styled.p<{ $status: ProductTemplateStatus }>`
  font-size: 1.2rem;
  line-height: 2.4rem;
  font-weight: 400;
  text-align: center;
  color: ${colors.neutral[900]};
  width: 10rem;
  vertical-align: middle;
  border-radius: 14px;
  background-color: ${({ $status }): string => {
    switch ($status) {
      case ProductTemplateStatus.IN_PROGRESS:
        return colors.yellow[200];
      case ProductTemplateStatus.READY:
        return colors.green[200];
      case ProductTemplateStatus.ARCHIVE:
        return colors.neutral[200];
      case ProductTemplateStatus.INITIAL_SEED:
        return colors.purple[200];
      default:
        return 'transparent';
    }
  }};
`;
